import React from 'react';

class MasterChannelLink extends React.Component {
  render() {
    let logoUrl = 'img/channelLogos/radio2.png';

    return (
      <div className="channelLink" onClick={this.props.handler}>
          <div className="channelLogoContainer">
            <img src={logoUrl} alt='' />
          </div>
          <p className="hidden">
            Radio 2
          </p>
      </div>
    );
  }

}

export default MasterChannelLink;